exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ui-icon{cursor:inherit;display:inline-block;font-size:1.5rem;height:1em;user-select:none;vertical-align:middle;width:1em}.ui-icon svg{fill:currentColor;height:1em;margin:0;padding:0;width:1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7b0a85a6!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/keen-ui/src/UiIcon.vue
// module id = 469
// module chunks = 22